import CryptoJS from 'crypto-js';

function decrypt(str, key, iv) {
  // const keyDel = CryptoJS.MD5(key).toString();
  // const ivDel = CryptoJS.MD5(iv).toString();
  const cryptoKey = CryptoJS.enc.Hex.parse(key);
  const cryptoIv = CryptoJS.enc.Hex.parse(iv);
  const decryptStr = CryptoJS.TripleDES.decrypt(str, cryptoKey, {
    iv: cryptoIv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7 });
  return decryptStr.toString(CryptoJS.enc.Utf8);
}

function encrypt(str, key, iv) {
  // const keyDel = CryptoJS.MD5(key).toString();
  // const ivDel = CryptoJS.MD5(iv).toString();
  const cryptoKey = CryptoJS.enc.Hex.parse(key);
  const cryptoIv = CryptoJS.enc.Hex.parse(iv);
  const encodeStr = CryptoJS.TripleDES.encrypt(str, cryptoKey, {
    iv: cryptoIv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7 });
  return encodeStr.toString();
}

function md5encode(str) {
  return CryptoJS.MD5(str).toString();
}

function base64encode(str) {
  const strDel = CryptoJS.enc.Utf8.parse(str);
  const base64 = CryptoJS.enc.Base64.stringify(strDel);
  return base64;
}

/**
 * 3des加密
 * @param {*} message
 * @param {*} key
 * @param {*} iv
 */
function encrypt3Des(message, key, iv) {
  const keyHex = CryptoJS.enc.Hex.parse(key);
  const ivHex = CryptoJS.enc.Hex.parse(iv);
  const encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: ivHex,
  });
  return encrypted.toString();
}
/**
 * passport接口经过3des加密的，用此方法解密
 * @param {*} message
 * @param {*} key
 * @param {*} iv
 */
function decrypt3Des(message, key, iv) {
  const keyHex = CryptoJS.enc.Hex.parse(key);
  const ivHex = CryptoJS.enc.Hex.parse(iv);
  // 第三步再进行解密
  const decrypted = CryptoJS.TripleDES.decrypt(message, keyHex, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: ivHex,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

// AES 解密方法
function decryptAES(word) {
  const key = CryptoJS.enc.Utf8.parse("www.ppcnsuning.c");
  const iv = CryptoJS.enc.Utf8.parse('c.gninusncpp.www');
  const base64 = CryptoJS.enc.Base64.parse(word);
  const src = CryptoJS.enc.Base64.stringify(base64);
  const decryptx = CryptoJS.AES.decrypt(src, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    adding: CryptoJS.pad.Pkcs7,
  });
  const decryptedStr = decryptx.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
}

export {
  encrypt,
  decrypt,
  md5encode,
  base64encode,
  encrypt3Des,
  decrypt3Des,
  decryptAES,
};
